export default "__VITE_ASSET__088b4c55__"